<template>
  <div class="lender-container">
    <div class="user-profile-container">
      <div class="info">
        <div class="name-block">
          <div class="user-name">
            {{ profile.name_ru.family_name_ru }}
            {{ profile.name_ru.given_name_ru }}
          </div>
          <div class="user-status" :class="`${profile.status}-profile`">
            {{ $t(`message.profile.status.${profile.status}`) }}
          </div>
        </div>
        <div class="user-role">
          <span>{{ $t("message.profile.role.title") }}</span>
          <span class="role">
            {{ $t(`message.profile.role.${this.profile.role}`) }}
          </span>
        </div>
      </div>
      <button class="settings-btn" @click.stop="goToSettings()">
        <img src="../../../public/custom/images/settings.svg" alt="settings">
        <span>{{ $t('message.profile.settings') }}</span>
      </button>
    </div>
    <!-- <div class="user-info-container">
      <div class="user-status" :class="`${profile.status}-profile`">
        {{ $t(`message.profile.status.${profile.status}`) }}
      </div>
      <div class="user-name">
        {{ profile.name_ru.family_name_ru }}
        {{ profile.name_ru.given_name_ru }}
      </div>
      <div class="user-location">{{ userLocality }}</div>
      <div class="user-role">
        <span>{{ $t('message.profile.role.title') }}</span>
        &ensp;
        <span class="role">
          {{ $t(`message.profile.role.${this.profile.role}`) }}
        </span>
      </div>
    </div> -->
    <div class="offer-container">
      <div class="offer-block">
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.amount.title')"
            :placeholder="amountOfferPlaceholder"
            :name="'offerAmount'"
            :validate-rules="'offerAmount'"
            :mask-pattern="'######'"
            v-model="newOffer.loan_amount"
          />
          
        </div>
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.term.title')"
            :placeholder="amountTermPlaceholder"
            :name="'offerTerm'"
            :validate-rules="'offerTerm'"
            :mask-pattern="'##'"
            v-model="newOffer.loan_term_days"
          />
        </div>
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.percent.title')"
            :placeholder="amountPercentPlaceholder"
            :name="'offerPercent'"
            :validate-rules="'offerPercent'"
            :mask-pattern="'####'"
            v-model="newOffer.annual_percent"
          />
        </div>
        <div class="middle-offer-item">
          <div class="expected-income-block">
            <div class="expected-income-label" :class="{ 'expected-income-invalid': isExpectedIncomeInvalid }">
                {{ $t('message.profile.lender.offer.income.title') }}
              </div>
            <div class="expected-income" :class="{ 'expected-income-invalid': isExpectedIncomeInvalid }">
              {{ expectedIncome }}
            </div>
          </div>
          <div class="notice-mobile-block">
            <div class="notice-desktop col-red mb-10">* - доход по займу не может превышать половины суммы займа</div>
            <div class="notice-desktop">* - без учёта комиссий</div>
          </div>
        </div>
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.rating.title')"
            :placeholder="$t('message.profile.lender.offer.rating.placeholder')"
            :name="'offerRating'"
            :validate-rules="'offerRating'"
            :mask-pattern="'###'"
            v-model="newOffer.borrower_min_rating"
            :isHaveLinkNotice="true"
            :linkNoticePath="'/questions'"
          />
        </div>
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.count.title')"
            :placeholder="$t('message.profile.lender.offer.count.placeholder')"
            :name="'offerCount'"
            :validate-rules="'offerCount'"
            :mask-pattern="'##'"
            v-model="newOffer.loan_max_count"
            :is-have-notice="true"
            :notice-message="$t('message.profile.lender.offer.count.notice')"
            class="notice-input"
          />
        </div>
        <div class="button-block">
          <base-button
            :text="$t('message.profile.lender.offer.btn')"
            :disabled="isCreateOfferBtnDisabled"
            @click="createOffer()"
            :min-height="'40px'"
          />
        </div>
      </div>

      <div class="notice-desktop-block">
        <div class="notice-desktop col-red mb-10 fw-600">* - доход по займу не может превышать половины суммы займа</div>
        <div class="notice-desktop">* - без учёта комиссий</div>
      </div>
    </div>

    <div class="offers-temporarily-blocked" v-if="isOffersTemporarilyBlockedVisible">
      <div class="offers-temporarily-blocked-message">
        {{ $t('message.profile.lender.offersTemporarilyBlocked.text') }}
      </div>
      <div class="offers-temporarily-blocked-btn">
        <base-button
          :text="$t('message.profile.lender.offersTemporarilyBlocked.btn')"
          :is-loading="isConfirmCardFoundsLoading"
          :disabled="isConfirmCardFoundsLoading"
          :min-height="'40px'"
          @click="confirmCardFounds()"
        />
      </div>
    </div>

    <div class="notice-block" v-if="isVerifyingCardBlockVisible">
      {{ $t('message.profile.borrower.notice') }}
    </div>
    <div class="cards-block" v-if="isVerifyingCardBlockVisible">
      <verify-card v-for="card of lenderVerifyCardsList" :key="card.name" :settings="card" @action="lenderCardAction"/>
    </div>

    <div class="bottom-line"></div>

    <div class="active-offers-container loans-container">
      <div class="active-offers-title">
        {{ $t('message.profile.borrower.activeOffers.title') }}
      </div>
      <div class="filters-block" @keyup.enter="setLoansFilter()">
        <div class="filter-block">
          <base-select
            :key="loansFilterSelectKey"
            :placeholder="$t('message.profile.lender.loans.filter.status')"
            :default-value="loansFilterStatus"
            :dictionary-path="'message.profile.lender.loans.filterStatus.list.'"
            :options-list="['overdue', 'current_debt', 'signing']"
            v-model="loansFilterStatus"
          />
        </div>
        <div class="filter-block">
          <input
            type="text"
            class="filter-input"
            v-model="loansFilter.full_name_borrower"
            :placeholder="$t('message.profile.lender.loans.filter.borrower')"
          >
        </div>
        <div class="datepicker-block">
          <base-datepicker
            v-model="loansFilter.receipt_date"
            :default-value="loansFilter.receipt_date"
            :format="'DD.MM.YYYY'"
            :range="true"
            :placeholder="$t('message.profile.lender.loans.filter.issued')"
          />
        </div>
        <div class="button-block">
          <base-button
            :text="$t('message.profile.lender.loans.filter.apply')"
            :min-height="'36px'"
            @click="setLoansFilter()"
          />
        </div>
        <div class="button-block">
          <base-button
            class="reset-filter-btn"
            :text="$t('message.profile.lender.loans.filter.reset')"
            :min-height="'36px'"
            @click="resetLoansFilter()"
          />
        </div>
      </div>
      <div class="loans-scroll-content">
        <div class="offers-item-header">
          <div class="agreement">№ договора</div>
          <div class="name">Заемщик</div>
          <div class="rating">Рейтинг</div>
          <div class="issued">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</div>
          <div class="amount">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</div>
          <div class="term">{{ $t('message.profile.borrower.activeOffers.items.term') }}</div>
          <div class="percent">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</div>
          <div class="income">{{ $t('message.profile.borrower.activeOffers.items.income') }}</div>
          <div class="issued-by">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</div>
          <div class="peni">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</div>
          <div class="total-amount">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</div>
          <div class="status">{{ $t('message.profile.borrower.activeOffers.items.status') }}</div>
          <div class="pay"></div>
        </div>
        <lender-loan-item
          v-for="item of loansList"
          :key="item.id"
          :item="item"
          @openTransactions="openLoanDetails"
          @openExpiredModal="openExpiredModal"
          @openLawsuitModal="openLawsuitModal"
        />
        <div v-if="isLoansListEmpty" class="empty-list">{{ $t('message.profile.borrower.activeOffers.noData') }}</div>
      </div>
      <div class="table-footer">
        <div class="notice">* - без учёта комиссий</div>
        <div v-if="loansPagesCounter > 0" class="pagination-block">
          <pagination
            :prevButtonPlaceholder="'<'"
            :nextButtonPlaceholder="'>'"
            :current-page="loansParams.page"
            :pages-count="loansPagesCounter"
            :total-count="loansCount"
            :page-size="loansParams.size"
            @choice="setLoansPage"
          />
        </div>
      </div>
    </div>

    <div class="active-offers-container offers-container">
      <div class="active-offers-title">
        {{ $t('message.profile.lender.activeOffers.title') }}
      </div>
      <div class="filters-block" @keyup.enter="setOffersFilter()">
        <div class="filter-block">
          <base-select
            :key="offersFilterSelectKey"
            :placeholder="$t('message.profile.lender.loans.filter.status')"
            :default-value="offersFilterStatus"
            :dictionary-path="'message.profile.lender.activeOffers.published.'"
            :options-list="['published', 'not_published']"
            v-model="offersFilterStatus"
          />
        </div>
        <div class="button-block">
          <base-button
            :text="$t('message.profile.lender.loans.filter.apply')"
            :min-height="'36px'"
            @click="setOffersFilter()"
          />
        </div>
        <div class="button-block">
          <base-button
            class="reset-filter-btn"
            :text="$t('message.profile.lender.loans.filter.reset')"
            :min-height="'36px'"
            @click="resetOffersFilter()"
          />
        </div>
      </div>
      <div class="offers-item-header">
        <!-- <div class="id"></div> -->
        <div class="amount">{{ $t('message.profile.lender.activeOffers.items.amount') }}</div>
        <div class="term">{{ $t('message.profile.lender.activeOffers.items.term') }}</div>
        <div class="percent">{{ $t('message.profile.lender.activeOffers.items.percent') }}</div>
        <div class="income">{{ $t('message.profile.lender.activeOffers.items.income') }}</div>
        <div class="rating">{{ $t('message.profile.lender.activeOffers.items.rating') }}</div>
        <div class="count">{{ $t('message.profile.lender.activeOffers.items.count') }}</div>
        <div class="status">{{ $t('message.profile.lender.activeOffers.items.status') }}</div>
        <div class="menu"></div>
      </div>
      <lender-offer-item
        v-for="item of offersList" :key="item.createdAt"
        :item="item"
        @changeOfferStatus="changeOfferStatus"
        @deleteOffer="deleteOffer"
      />
      <div v-if="isOffersListEmpty" class="empty-list">{{ $t('message.profile.lender.activeOffers.noData') }}</div>
      <div class="table-footer">
        <div class="notice">* - без учёта комиссий</div>
        <div v-if="offersPagesCounter > 0" class="pagination-block">
          <pagination
            :prevButtonPlaceholder="'<'"
            :nextButtonPlaceholder="'>'"
            :current-page="offersParams.page"
            :pages-count="offersPagesCounter"
            :total-count="lenderOffersCount"
            :page-size="offersParams.size"
            @choice="setOffersPage"
          />
        </div>
      </div>
    </div>
    <base-modal
      v-if="isShowExpiredModal"
      @close="closeExpiredModal()"
    >
      <template #header>
        <div class="modal-header expired-modal-header">
          <img @click.stop="closeExpiredModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="modal-title expired-modal-title">{{ $t('message.profile.lender.expiredModal.title') }}</div>
        <div class="btns-block expired-modal-btns-block">
          <div class="btn-container">
            <base-button
              :text="$t('message.profile.lender.expiredModal.advicesBtn')"
              @click="openClaimAdvicesModal()"
            />
          </div>
          <div class="btn-container">
            <base-button
              :text="$t('message.profile.lender.expiredModal.claimBtn')"
              :disabled="isClaimBtnLoading"
              :is-loading="isClaimBtnLoading"
              @click="createClaim()"
            />
          </div>
        </div>
      </template>
    </base-modal>

    <base-modal
      v-if="isShowLawsuitModal"
      @close="closeLawsuitModal()"
    >
      <template #header>
        <div class="modal-header expired-modal-header">
          <img @click.stop="closeLawsuitModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="modal-title expired-modal-title">Вы воспользовались функцией “Подача искового заявления в Третейский Суд”.</div>
        <div class="btns-block expired-modal-btns-block">
          <div class="btn-container">
            <base-button
              :text="$t('message.profile.lender.expiredModal.advicesBtn')"
              @click="openLawsuitAdvicesModal()"
            />
          </div>
          <div class="btn-container">
            <base-button
              text="Подать заявление"
              :disabled="isLawsuitBtnLoading"
              :is-loading="isLawsuitBtnLoading"
              @click="createLawsuit()"
            />
          </div>
        </div>
      </template>
    </base-modal>
    
    <base-modal
      @close="closeClaimAdvicesModal()"
      v-if="isShowClaimAdvicesModal"
    >
      <template #header>
        <div class="modal-header">
          <img @click.stop="closeClaimAdvicesModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="claim-advices-title">
          {{ $t('message.profile.lender.expiredModal.claimAdvices.title') }}
        </div>
        <div class="claim-advices-list">
          <p>
            {{ $t('message.profile.lender.expiredModal.claimAdvices.first') }}
          </p>
          <p>
            {{ $t('message.profile.lender.expiredModal.claimAdvices.secondStart') }}
            <b>{{ $t('message.profile.lender.expiredModal.claimAdvices.secondBold') }}</b>
            {{ $t('message.profile.lender.expiredModal.claimAdvices.secondEnd') }}
          </p>
          <p>
            {{ $t('message.profile.lender.expiredModal.claimAdvices.third') }}
          </p>
          <p>
            <b>{{ $t('message.profile.lender.expiredModal.claimAdvices.fourth') }}</b>
          </p>
          <div class="claim-advices-btns-block">
            <div class="claim-advices-btns-container">
              <base-button
                :text="claimAdvicesSubmitText"
                :disabled="claimAdvicesBtnDisabled"
                :is-loading="claimAdvicesBtnLoading"
                @click="submitClaimAdvicesAction()"
              />
            </div>
          </div>
        </div>
      </template>
    </base-modal>
    <base-modal
      v-if="isShowDeleteOfferModal"
      @close="closeDeleteOfferModal()"
    >
      <template #main>
        <div class="delete-offer-modal">
          <div class="modal-header">
            <img @click.stop="closeDeleteOfferModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
          </div>
          <div class="delete-offer-modal-icon">!</div>
          <div class="delete-offer-modal-title">
            {{ $t('message.profile.lender.deleteOffer.title') }}
          </div>
          <div class="delete-offer-modal-text">
            {{ $t('message.profile.lender.deleteOffer.text') }}
          </div>
          <div class="delete-offer-modal-btns">
            <div class="delete-offer-modal-btn-container">
              <base-button
                :text="$t('message.profile.lender.deleteOffer.confirmBtn')"
                :min-height="'40px'"
                @click="confirmDeleteOffer()"
              />
            </div>
            <div class="delete-offer-modal-btn-container">
              <base-button
                :text="$t('message.profile.lender.deleteOffer.cancelBtn')"
                class="delete-offer-cancel-btn"
                :min-height="'40px'"
                @click="closeDeleteOfferModal()"
              />
            </div>
          </div>
        </div>
      </template>
    </base-modal>
    <actual-msi-info-modal
      v-if="isActualMsiInfoModalVisible"
      description-key="message.profile.verifyCards.annualActualInfo.modalDescription"
      @close="closeActualMsiInfoModal()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTextInput from '../../components/base/BaseTextInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import lenderOfferItem from './lenderOfferItem.vue';
import lenderLoanItem from './lenderLoanItem.vue';
import verifyCard from './verifyCard.vue';
import BaseModal from '../../components/base/BaseModal.vue';
import Pagination from '../../components/common/Pagination.vue';
import BaseSelect from '../../components/base/BaseSelect.vue';
import BaseDatepicker from '../../components/base/BaseDatepicker.vue';
import ActualMsiInfoModal from '../Settings/actualMsiInfo/actualMsiInfoModal.vue';

export default {
  name: 'LenderProfile',
  inject: ['$httpService'],
  components: {
    BaseTextInput,
    BaseButton,
    lenderOfferItem,
    lenderLoanItem,
    verifyCard,
    BaseModal,
    Pagination,
    BaseSelect,
    BaseDatepicker,
    ActualMsiInfoModal
  },
  data() {
    return {
      newOffer: {
        loan_amount: '',
        annual_percent: '',
        loan_term_days: '',
        borrower_min_rating: '',
        loan_max_count: ''
      },
      isBtnLoading: false,
      isClaimBtnLoading: false,
      isLawsuitBtnLoading: false,
      isOfferMenuOpen: false,
      isShowExpiredModal: false,
      isShowLawsuitModal: false,
      isShowClaimAdvicesModal: false,
      isShowDeleteOfferModal: false,
      isActualMsiInfoModalVisible: false,
      isConfirmCardFoundsLoading: false,
      claimAdvicesMode: 'claim',
      claimLoanPublicId: '',
      lawsuitLoanPublicId: '',
      offerToDeleteId: '',
      offersParams: {
        page: 0,
        size: 10
      },
      offersFilter: {
        status: undefined
      },
      offersFilterStatus: '',
      offersFilterSelectKey: 0,
      loansParams: {
        page: 0,
        size: 10
      },
      loansFilter: {
        full_name_borrower: undefined,
        receipt_date: undefined,
        status: undefined
      },
      loansFilterStatus: '',
      loansFilterSelectKey: 0
    }
  },
  created() {
    this.restoreLoansState();
  },
  methods: {
    restoreLoansState() {
      const { loansParams, loansFilter, loansFilterStatus } = this.$route.params || {};

      if (!loansParams && !loansFilter && !loansFilterStatus) {
        return;
      }

      this.loansParams = {
        ...this.loansParams,
        ...(loansParams || {})
      };
      this.loansFilter = {
        ...this.loansFilter,
        ...(loansFilter || {})
      };
      this.loansFilterStatus = loansFilterStatus || '';
    },
    getLoansRequestParams() {
      return {
        ...this.loansParams,
        filter: this.loansFilter
      };
    },
    async fetchLoansList() {
      this.$store.dispatch('loading', true);

      try {
        await this.$store.dispatch('getLoansList', this.getLoansRequestParams());
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    async setLoansFilter() {
      this.loansParams.page = 0;
      await this.fetchLoansList();
    },
    async resetLoansFilter() {
      this.loansParams.page = 0;
      this.loansFilterStatus = '';
      this.loansFilterSelectKey += 1;
      this.loansFilter = {
        full_name_borrower: undefined,
        receipt_date: undefined,
        status: undefined
      };
      await this.fetchLoansList();
    },
    async setLoansPage(page) {
      this.loansParams.page = page;
      await this.fetchLoansList();
    },
    getLoansBackRouteParams() {
      return {
        loansParams: {
          ...this.loansParams
        },
        loansFilter: {
          ...this.loansFilter
        },
        loansFilterStatus: this.loansFilterStatus
      };
    },
    openLoanDetails(id) {
      this.$router.push({
        name: 'loan',
        params: {
          id,
          backRouteName: 'profile',
          backRouteParams: this.getLoansBackRouteParams()
        }
      });
    },
    getOffersRequestParams() {
      return {
        ...this.offersParams,
        filter: this.offersFilter
      };
    },
    async refreshLenderProfileData() {
      await Promise.all([
        this.$store.dispatch('updateProfile'),
        this.$store.dispatch('getLoansList', this.getLoansRequestParams()),
        this.$store.dispatch('getLenderOffersList', this.getOffersRequestParams())
      ]);
    },
    async confirmCardFounds() {
      if (this.isConfirmCardFoundsLoading) {
        return;
      }

      this.isConfirmCardFoundsLoading = true;
      let toastText = '';
      let isConfirmSuccess = false;

      try {
        await this.$httpService.auth.confirmCardFounds();
        toastText = this.$t('message.profile.lender.offersTemporarilyBlocked.success');
        isConfirmSuccess = true;
      } catch (error) {
        toastText = this.$t('message.profile.lender.offersTemporarilyBlocked.error');
      }

      try {
        await this.refreshLenderProfileData();
      } catch (error) {
        console.log(error);
      } finally {
        this.isConfirmCardFoundsLoading = false;
        if (isConfirmSuccess) {
          this.$toast.success(toastText);
        } else {
          this.$toast.error(toastText);
        }
      }
    },
    async fetchOffersList() {
      this.$store.dispatch('loading', true);

      try {
        await this.$store.dispatch('getLenderOffersList', this.getOffersRequestParams());
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    async setOffersFilter() {
      this.offersParams.page = 0;
      await this.fetchOffersList();
    },
    async resetOffersFilter() {
      this.offersParams.page = 0;
      this.offersFilterStatus = '';
      this.offersFilterSelectKey += 1;
      this.offersFilter = {
        status: undefined
      };
      await this.fetchOffersList();
    },
    async setOffersPage(page) {
      this.offersParams.page = page;
      await this.fetchOffersList();
    },
    closeClaimAdvicesModal() {
      this.isShowClaimAdvicesModal = false;
    },
    openClaimAdvicesModal() {
      this.claimAdvicesMode = 'claim';
      this.closeExpiredModal();
      this.isShowClaimAdvicesModal = true;
    },
    openLawsuitAdvicesModal() {
      this.claimAdvicesMode = 'lawsuit';
      this.closeLawsuitModal();
      this.isShowClaimAdvicesModal = true;
    },
    openExpiredModal(loanPublicId) {
      this.claimLoanPublicId = loanPublicId;
      this.isShowExpiredModal = true;
    },
    closeExpiredModal() {
      this.isShowExpiredModal = false;
    },
    openLawsuitModal(loanPublicId) {
      this.lawsuitLoanPublicId = loanPublicId;
      this.isShowLawsuitModal = true;
    },
    closeLawsuitModal() {
      this.isShowLawsuitModal = false;
    },
    submitClaimAdvicesAction() {
      if (this.isClaimAdvicesClaimMode) {
        this.createClaim();
        return;
      }

      this.createLawsuit();
    },
    async createClaim() {
      this.isClaimBtnLoading = true;

      try {
        const response = await this.$httpService.claim.createClaim(this.claimLoanPublicId);
        const publicId = response?.data?.public_id;

        if (!publicId) {
          throw new Error('Claim create failed');
        }

        this.$router.push({
          name: 'sign-claim',
          params: {
            id: publicId,
            backRouteName: 'profile',
            backRouteParams: this.getLoansBackRouteParams()
          }
        });
      } catch (error) {
        this.closeExpiredModal();
        this.closeClaimAdvicesModal();
        this.$toast.error('Не удалось создать претензию');
      } finally {
        this.isClaimBtnLoading = false;
      }
    },
    async createLawsuit() {
      this.isLawsuitBtnLoading = true;

      try {
        const response = await this.$httpService.claim.createLawsuite(this.lawsuitLoanPublicId);
        const publicId = response?.data?.public_id;

        if (!publicId) {
          throw new Error('Lawsuit create failed');
        }

        this.$router.push({
          name: 'lawsuit-sign',
          params: {
            id: publicId,
            backRouteName: 'profile',
            backRouteParams: this.getLoansBackRouteParams()
          }
        });
      } catch (error) {
        this.closeLawsuitModal();
        this.closeClaimAdvicesModal();
        this.$toast.error('Не удалось подать заявление');
      } finally {
        this.isLawsuitBtnLoading = false;
      }
    },
    async createOffer() {
      const modifyedData = {};

      for (let key in this.newOffer) {
        modifyedData[key] = Number(this.newOffer[key]);
      }

      modifyedData.loan_amount = modifyedData.loan_amount * 100;

      const payload = {...modifyedData};

      try {
        const list = await this.$httpService.offers.createOffer(payload);
        
        if (list.data) {
          this.$toast.success(this.$t('message.profile.lender.offer.toastMsg'));
        }
        this.offersParams.page = 0;
        this.$emit('createOffer', list.data);
      } catch (error) {
        console.log(error);
      }
    },
    offerMenuToggle() {
      this.isOfferMenuOpen = !this.isOfferMenuOpen;
    },
    async changeOfferStatus(data) {
      this.offersParams.page = 0;
      await this.$store.dispatch('changeOfferStatus', data);
      await this.fetchOffersList();
    },
    async deleteOffer(publicId) {
      this.offerToDeleteId = publicId;
      this.isShowDeleteOfferModal = true;
    },
    closeDeleteOfferModal() {
      this.isShowDeleteOfferModal = false;
      this.offerToDeleteId = '';
    },
    confirmDeleteOffer() {
      if (!this.offerToDeleteId) {
        return;
      }

      this.offersParams.page = 0;
      this.$emit('deleteOffer', this.offerToDeleteId);
      this.closeDeleteOfferModal();
    },
    lenderCardAction(name) {
      if (name === 'card') {
        this.$router.push({ name: 'cards' });
      } else if (name === 'agreement') {
        this.$router.push({ name: 'scoringAgreement' });
      } else if (name === 'email') {
        this.$router.push({ name: 'change-contact-info' });
      } else if (name === 'annualActualInfo') {
        this.isActualMsiInfoModalVisible = true;
      }
    },
    closeActualMsiInfoModal() {
      this.isActualMsiInfoModalVisible = false;
    },
    goToSettings() {
      this.$router.push({ name: 'settings' });
    }
  },
  computed: {
    ...mapGetters(['profile', 'offersList', 'loansList', 'loansCount', 'lenderOffersCount']),
    isClaimAdvicesClaimMode() {
      return this.claimAdvicesMode === 'claim';
    },
    claimAdvicesSubmitText() {
      return this.isClaimAdvicesClaimMode ? this.$t('message.profile.lender.expiredModal.claimBtn') : 'Подать заявление';
    },
    claimAdvicesBtnDisabled() {
      return this.isClaimAdvicesClaimMode ? this.isClaimBtnLoading : this.isLawsuitBtnLoading;
    },
    claimAdvicesBtnLoading() {
      return this.isClaimAdvicesClaimMode ? this.isClaimBtnLoading : this.isLawsuitBtnLoading;
    },
    isExpectedIncomeInvalid() {
      if (!this.newOffer.loan_amount || !this.expectedIncome) {
        return false;
      }
      const loanAmount = Number(this.newOffer.loan_amount);
      const income = Number(this.expectedIncome);
      if (Number.isNaN(loanAmount) || Number.isNaN(income)) {
        return false;
      }
      return income > loanAmount / 2;
    },
    userLocality() {
      return `${this.profile.address.locality}, ${this.profile.address.country}`;
    },
    isOffersListEmpty() {
      return this.offersList.length === 0;
    },
    isLoansListEmpty() {
      return this.loansList.length === 0;
    },
    loansPagesCounter() {
      return Math.ceil(this.loansCount / this.loansParams.size);
    },
    offersPagesCounter() {
      return Math.ceil(this.lenderOffersCount / this.offersParams.size);
    },
    lenderVerifyCardsList() {
      return [
        {
          name: 'email',
          disabled: false,
          visible: !this.profile?.emailVerified,
        },
        // {
        //   name: 'agreement',
        //   descKey: 'descLender',
        //   disabled: !this.profile?.emailVerified,
        //   visible: this.profile?.expiredCreditRegisterAgreement
        // },
        {
          name: 'card',
          disabled: !this.profile?.emailVerified,
          visible: !this.profile?.default_card_id,
        },
        {
          name: 'annualActualInfo',
          disabled: false,
          visible: this.profile?.annual_actual_info?.required,
        },
      ];
    },
    isVerifyingCardBlockVisible() {
      return this.lenderVerifyCardsList.some((item) => item.visible);
    },
    isOffersTemporarilyBlockedVisible() {
      return this.profile?.offersTemporarilyBlocked === true;
    },
    isCreateOfferBtnDisabled() {
      return this.isHasValidationErrors || this.isHasEmptyFields || !this.profile.default_card_id || this.isExpectedIncomeInvalid;
    },
    isHasValidationErrors() {
      return this.errors.items.length > 0;
    },
    isHasEmptyFields() {
      return !this.newOffer.annual_percent || !this.newOffer.loan_amount ||
        !this.newOffer.loan_term_days || !this.newOffer.borrower_min_rating || !this.newOffer.loan_max_count;
    },
    expectedIncome() {
      const year = new Date().getFullYear();
      const numberOfDays = (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) ? 366 : 365;
      let expected_income = parseFloat(((+this.newOffer.loan_amount * 100) * +this.newOffer.annual_percent / 100 / numberOfDays * +this.newOffer.loan_term_days));

      return this.isHasValidationErrors ? 0 : (expected_income / 100.00).toFixed(2);
    },
    amountOfferPlaceholder() {
      const amountFrom = window.entityCabinetSettings.offer.minAmount;
      const amountTo = window.entityCabinetSettings.offer.maxAmount;
      return `${this.$t('message.profile.lender.offer.amount.placeholderStart')} ${amountFrom} ${this.$t('message.profile.lender.offer.amount.placeholderEnd')} ${amountTo}`
    },
    amountTermPlaceholder() {
      const termFrom = window.entityCabinetSettings.offer.minTerm;
      const termTo = window.entityCabinetSettings.offer.maxTerm;
      return `${this.$t('message.profile.lender.offer.term.placeholderStart')} ${termFrom} ${this.$t('message.profile.lender.offer.term.placeholderEnd')} ${termTo} ${this.$t('message.profile.lender.offer.term.days')}`
    },
    amountPercentPlaceholder() {
      const percentFrom = window.entityCabinetSettings.offer.minPercent;
      const percentTo = window.entityCabinetSettings.offer.maxPercent;
      return `${this.$t('message.profile.lender.offer.percent.placeholderStart')} ${percentFrom} ${this.$t('message.profile.lender.offer.percent.placeholderEnd')} ${percentTo}`
    },
  },
  watch: {
    loansFilterStatus(value) {
      if (value) {
        this.loansFilter.status = value;
      } else {
        this.loansFilter.status = undefined;
      }
    },
    offersFilterStatus(value) {
      if (value) {
        this.offersFilter.status = value;
      } else {
        this.offersFilter.status = undefined;
      }
    },
    'loansFilter.receipt_date'(value) {
      if (value && value[0] === null) {
        this.loansFilter.receipt_date = undefined;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .lender-container {
    @include base-page-container;

    flex-direction: column;
    color: #121212;
  }

  .user-info-container {
    display: flex;
    flex-direction: column;
  }

  .user-profile-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    border-bottom: 1px solid #41bf7b;
  }

  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .name-block {
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 20px;
  }

  .settings-btn {
    all: unset;
    width: 207px;
    height: 40px;
    box-sizing: border-box;
    padding: 6px 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    color: #41bf7b;
    border: 2px solid #41bf7b;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;

    span {
      font-size: 14px;
      font-weight: 600;
      color: rgb(26, 141, 72);
    }

    &:hover {
      transform: scale(1.03);
    }
  }

  .user-name {
    font-style: normal;
    font-size: 18px;
    line-height: 30px;
    font-weight: 600;
    display: flex;
    align-items: center;
    letter-spacing: 0.01em;
    color: rgb(18, 18, 18);
    text-transform: uppercase;
  }

  .user-location,
  .user-role {
    gap: 4px;
    font-size: 14px;
    line-height: 22px;
  }

  .user-role {
    margin-bottom: 5px;
    display: flex;
    align-items: flex-end;
    gap: 4px;
    font-size: 14px;
    line-height: 22px;
  }

  .role {
    font-weight: 600;
    color: #181A1B;
  }

  .offer-container {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .notice-desktop-block {
    display: flex;
    flex-direction: column;
  }

  .notice-mobile-block {
    display: none;
  }

  .offer-block {
    display: flex;
    flex-wrap: wrap;
  }

  .middle-offer-item {
    width: 180px;
    margin-right: 25px;
    margin-bottom: 20px;
  }

  .middle-offer-item ::v-deep .label-text,
  .small-offer-item ::v-deep .label-text {
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
  }

  .middle-offer-item ::v-deep .input-wrapper {
    margin-bottom: 0;
  }

  .notice-desktop {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #333333;
  }

  .small-offer-item {
    width: 90px;
    margin-right: 25px;
  }

  .expected-income-label {
    @include base-input-label;

    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
  }

  .expected-income {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    outline: none;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 135%;
    background-color: rgba(239, 239, 239, 0.92);
    color: var(--base-input-disabled-color);
    height: 42px;
    border-radius: var(--base-input-border-radius);
    border: 1px solid var(--base-input-valid-border-bgc);
  }

  .expected-income-invalid {
    border-color: var(--base-input-invalid-border-bgc);
    color: var(--base-input-invalid-border-bgc);
  }

  .button-block {
    margin-top: 32px;
    width: 265px;
    height: 60px;
  }

  .active-offers-container {
    @include active-offers-container;

    margin-top: 60px;
  }

  .active-offers-title {
    @include active-offers-title;
  }

  .offers-item-header {
    @include offers-item-header;
  }

  .id {
    width: 11%;
    margin-right: 2%;
    @include overflow-elipsis;
  }

  .amount {
    width: 10%;
    margin-right: 2%;
  }

  .term {
    width: 11%;
    margin-right: 2%;
  }

  .percent {
    width: 10%;
    margin-right: 2%;
  }

  .income {
    width: 9%;
    margin-right: 2%;
  }

  .rating {
    width: 7%;
    margin-right: 2%;
  }

  .count {
    width: 10%;
    margin-right: 2%;
  }

  .status {
    width: 10%;
    margin-right: 2%;
  }

  .menu {
    width: 6%;
    display: flex;
    justify-content: flex-end;
    position: relative;
  }

  .published-status {
    width: 48px;
    padding: 8px 15px;
    box-sizing: border-box;
    background: #D6F9D3;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #21A25C;
  }

  .unpublished-status {
    width: 55px;
    padding: 8px 15px;
    box-sizing: border-box;
    background: #FFDBDB;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #C93434;
  }

  .offer-menu-img {
    margin-right: 21px;
    height: 22px;
    width: 22px;
    cursor: pointer;
  }

  .offer-menu {
    padding: 10px 15px;
    box-sizing: border-box;
    position: absolute;
    top: -43px;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #CDCDCD;
    border-radius: 10px;
    font-size: 16px;
    line-height: 135%;
    color: #333333;
    white-space: nowrap;
  }

  .filters-block {
    width: 100%;
    min-height: 36px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 16px;

    .filter-block {
      width: 190px;
      height: 36px;

      ::v-deep .input-wrapper {
        margin-bottom: 0;
        height: 100%;
      }

      ::v-deep .select-block {
        height: 36px;
      }

      ::v-deep .error-block {
        display: none;
      }
    }

    .button-block {
      width: 125px;
      height: 36px;
      margin-top: 0;

      ::v-deep .button {
        min-height: 36px;
        max-height: 36px;
        height: 36px;
        padding: 0 12px;
        border-radius: 6px;
      }
    }

    .reset-filter-btn {
      @include secondary-btn;
    }

    .datepicker-block {
      width: 230px;
      height: 36px;

      ::v-deep .mx-datepicker {
        width: 100%;
        height: 36px;
      }

      ::v-deep .mx-input-wrapper {
        height: 36px;
      }

      ::v-deep .mx-input {
        height: 36px;
      }
    }

    .filter-input {
      padding: 0 10px;
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      border-radius: 6px;
      border: 1px solid #CDCDCD;
      outline: none;

      &:active {
        border: 1px solid #DCDCDC;
      }
    }
  }

  .loans-container {
    @include loan-item-header;

    min-width: auto;
    overflow-x: auto;
    overflow-y: hidden;

    .pay {
      width: 56px;
    }
  }

  .loans-scroll-content {
    min-width: 1150px;
  }

  .modal-header {
    @include modal-close-block;

    width: 100%;
  }

  .modal-title {
    width: 70%;
    margin-bottom: 50px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #101010;
  }

  .btns-block {
    display: flex;
    gap: 24px;
  }

  .btn-container {
    height: 60px;
  }

  .expired-modal-header {
    width: 100%;
  }

  .expired-modal-title {
    width: 100%;
    max-width: 400px;
  }

  .expired-modal-btns-block {
    width: 100%;
    max-width: 520px;
  }

  .expired-modal-btns-block .btn-container {
    width: 248px;
    flex: 0 0 248px;
    min-width: 0;
  }

  .delete-offer-modal {
    width: 480px;
    max-width: calc(95vw - 30px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
  }

  .delete-offer-modal-icon {
    width: 96px;
    height: 96px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #F2A500;
    font-weight: 700;
    font-size: 52px;
    line-height: 52px;
    color: white;
  }

  .delete-offer-modal-title {
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0.1px;
    color: #022131;
  }

  .delete-offer-modal-text {
    width: 440px;
    max-width: 100%;
    margin-bottom: 40px;
    font-size: 14px;
    line-height: 22px;
    color: #022131;
  }

  .delete-offer-modal-btns {
    width: 440px;
    max-width: 100%;
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 20px;
  }

  .delete-offer-modal-btn-container {
    width: 140px;
    height: 40px;
  }

  .delete-offer-cancel-btn ::v-deep {
    background-color: white;
    border: 2px solid #41BF7B;
    box-sizing: border-box;
    color: #41BF7B;

    &:hover {
      color: white;
    }
  }

  .close-image {
    cursor: pointer;
  }

  .claim-advices-title {
    width: 100%;
    margin-bottom: 20px;
    padding-left: 20px;
    box-sizing: border-box;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: #101010;
  }

  .claim-advices-list {
    width: 580px;
    max-width: 100%;
    padding-right: 30px;
    box-sizing: border-box;
    max-height: 500px;
    overflow-y: auto;
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #121212;
    padding-left: 20px;

    p {
      margin-bottom: 10px;
    }

    p:last-of-type {
      margin-bottom: 50px;
    }

    b {
      font-weight: 700;
    }

  }

  .claim-advices-list::-webkit-scrollbar {
    width: 3px;
    height: 10px;
    margin-right: 5px;
    scroll-padding-top: 5px;
  }

  .claim-advices-list {
      scroll-padding-top: 5px;
  }

  .claim-advices-list::-webkit-scrollbar-track {
      background-color: #ECEEF0;
      border-radius: 20px;
  }

  .claim-advices-list::-webkit-scrollbar-thumb {
      background-color: #878787;
      border-radius: 20px;
  }

  .claim-advices-btns-block {
    width: 100%;
    margin-bottom: 35px;
    display: flex;
    justify-content: center;
  }

  .claim-advices-btns-container {
    width: 100%;
    height: 60px;
  }

  .offers-temporarily-blocked {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 30px;
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    background: #ffdbdb;
    border: 1px solid #c93434;
    border-radius: 6px;
  }

  .offers-temporarily-blocked-message {
    font-size: 14px;
    line-height: 19px;
    font-weight: 600;
    color: #c93434;
  }

  .offers-temporarily-blocked-btn {
    width: 180px;
    flex-shrink: 0;
  }

  .notice-block {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    color: rgb(18, 18, 18);
    margin-top: 8px;
    margin-bottom: 30px;
  }

  .cards-block {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 360px));
    justify-content: flex-start;
    gap: 24px;
    margin-bottom: 48px;
  }

  .bottom-line {
    width: 100%;
    height: 1px;
    background-color: #41BF7B;
  }

  .user-status {
  width: fit-content;
  padding: 4px 8px;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
}

.new-profile {
  color: #1a6fb5;
  background: #e3f0ff;
}

.active-profile {
  color: #21A15C;
  background: #D6F9D3;
}

.inactive-profile {
  color: #6b6b6b;
  background: #eceef0;
}

.waiting-profile,
.on_approval-profile,
.confirmed-profile {
  color: #CB7723;
  background: #FFF1D5;
}

.blocked-profile {
  color: #c93434;
  background: #ffdbdb;
}

.empty-list {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  box-sizing: border-box;
}

.table-footer {
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pagination-block {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
}

.more-block {
  margin-top: 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.more-container {
  width: fit-content;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  cursor: pointer;

  img {
    margin-left: 5px;
  }
}

.notice-input::v-deep .notice-msg {
  width: 290px;
  top: -150px;
}

.col-red {
  color: #fe0000;
}

.mb-10 {
  margin-bottom: 10px;
}

.fw-600 {
  font-weight: 600;
}

@media screen and (max-width: 870px) {
  .notice-input ::v-deep .notice-msg {
    width: 290px;
    top: -150px;
    left: -235px;
  }

  .notice-input ::v-deep .notice-arrow {
    left: 240px;
  }
}

@media screen and (max-width: 620px) {
  .expired-modal-btns-block {
    flex-direction: column;
  }

  .expired-modal-btns-block .btn-container {
    width: 100%;
    flex: 0 0 40px;
    height: 40px;
    margin-bottom: 12px;
  }

  .expired-modal-btns-block .btn-container:last-of-type {
    margin-bottom: 0;
  }

  .expired-modal-btns-block .btn-container:first-of-type {
    margin-right: 0;
  }

  .btns-block {
    gap: 0;
  }

  .delete-offer-modal {
    min-height: auto;
    padding-top: 32px;
  }

  .delete-offer-modal-icon {
    width: 80px;
    height: 80px;
    font-size: 44px;
    line-height: 44px;
  }

  .delete-offer-modal-text {
    margin-bottom: 32px;
  }

  .delete-offer-modal-btns {
    flex-direction: column;
    align-items: center;
    gap: 16px;

    div {
      width: 100%;
    }
  }
}

@media screen and (max-width: 850px) {
  .offers-temporarily-blocked {
    flex-direction: column;
    align-items: stretch;
  }

  .offers-temporarily-blocked-btn {
    width: 100%;
  }

  .cards-block {
    grid-template-columns: 1fr;
  }

  .loans-container .filters-block,
  .offers-container .filters-block {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 12px;

    .filter-block,
    .datepicker-block,
    .button-block {
      width: 100%;
    }

    .button-block ::v-deep .button {
      width: 100%;
      max-width: 100%;
    }
  }

  .loans-container .offers-item-header,
  .offers-item-header {
    display: none;
  }

  .loans-container .loans-scroll-content {
    min-width: auto;
  }

  .active-offers-container {
    min-width: auto;
  }
}

@media screen and (max-width: 600px) {
  .name-block {
    flex-direction: column-reverse;
    align-items: flex-start;
  }

  .user-profile-container {
    flex-direction: column;
  }

  .settings-btn {
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .button-block {
    margin-top: 0;
    width: 90%;
  }

  .loans-container .filters-block .button-block,
  .offers-container .filters-block .button-block {
    width: 100%;
  }
}

@media screen and (max-width: 500px) {
  .middle-offer-item {
    width: 90%;
  }

  .notice-desktop-block {
    display: none;
  }

  .notice-mobile-block {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
</style>